import e from"react";import t from"../utils/styled.js";import{mobileStyle as i}from"../utils/screen.js";const n=t("div")`
  width: 100%;
  height: 72px;
  padding-top: 15px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  white-space: pre;

  .bp5-dark &:hover,
  .bp5-dark &.active {
    color: #48aff0 !important;
  }

  &:hover,
  &.active {
    background-color: rgba(19, 124, 189, 0.2);
  }

  ${i("\n    height: 54px;\n    padding-top: 9px;\n    min-width: 72px;\n    width: min-content;\n  ")}
`;export const SectionTab=({children:t,name:i,onClick:o,active:p,iconSize:r})=>e.createElement(n,{onClick:o,className:"polotno-side-panel-tab"+(p?" active":"")},e.createElement("div",{style:{fontSize:(r||14)+"px"}},t),e.createElement("div",{style:{paddingTop:"5px"}},i));